import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const scrollToHash = (hash, attempt = 0) => {
  const id = hash.replace(/^#/, "");
  if (!id) return;

  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
    return;
  }

  // Lazy routes may not have mounted the target section yet.
  if (attempt < 30) {
    requestAnimationFrame(() => scrollToHash(hash, attempt + 1));
  }
};

const scrollWindowToTop = () => {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;

  document.querySelectorAll("main.overflow-auto").forEach((el) => {
    el.scrollTop = 0;
  });
};

/** Scroll to top on route change, or to a hash anchor when present. */
const ScrollToTop = () => {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      scrollToHash(hash);
      return;
    }

    scrollWindowToTop();
  }, [pathname, search, hash]);

  return null;
};

export default ScrollToTop;
